import React, { useState, useEffect } from 'react';
import { Col, Badge, Button, Accordion, Form, Spinner, Dropdown } from 'react-bootstrap';
import { X, Phone, Calendar, Mail, Bell, FileText, Clock, Target, Shield, Edit2, Check, XCircle, Save, RefreshCw, AlertCircle, Briefcase, ChevronDown, ChevronUp } from 'react-feather';
import { Icon } from '@iconify/react/dist/iconify.js';
import { updateUserProfile, getProfessionalSituation, updateInvestmentCriteria } from '../helper/Api/AdminApi';
import { toast } from 'react-toastify';

const customStyles = `
.personal-fields {
  border-bottom: 2px dashed #0000001A !important;
  padding: 5px;
  transition: all 0.2s ease;
}
.personal-fields.editing {
  background-color: #FFFAF0;
  border-bottom: 2px solid #CBA370 !important;
  padding: 5px 10px;
  border-radius: 6px;
}
.personal-fields.error {
  border-bottom: 2px solid #DC3545 !important;
  background-color: #FFF5F5;
}
.land-details-text {
  font-size: 14px;
  font-weight: 500;
  color: black;
}
.land-details-value {
  font-size: 14px;
  font-weight: 600;
  color: #126B3A;
  text-align: center;
}
.subscription-history-item {
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  background-color: #F9FAFB;
}
.subscription-title {
  color: #CBA370;
  font-weight: 600;
  font-size: 16px;
}
.subscription-detail {
  color: #374151;
  font-size: 14px;
  margin-top: 4px;
}
.subscription-date {
  color: #6B7280;
  font-size: 12px;
}
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #6B7280;
}
.accordion-button:not(.collapsed) {
  background-color: #F8FDF8 !important;
  color: #CBA370 !important;
  box-shadow: none;
}
.accordion-button:focus {
  border-color: #CBA370;
  box-shadow: 0 0 0 0.25rem rgba(203, 163, 112, 0.25);
}
.question-section {
  border-left: 2px solid #CBA370;
  padding-left: 10px;
  margin-bottom: 14px;
}
.question-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}
.option-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.option-label {
  font-size: 12.5px;
  color: #374151;
  line-height: 1.3;
}
.checked-option {
  color: #CBA370;
  font-weight: 500;
}
.accordion-item {
  border: 1px solid #E5E7EB !important;
  border-radius: 8px !important;
}
.accordion-header button {
  padding: 10px 14px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}
.accordion-body {
  padding: 12px 14px !important;
}
.accordion-button::after {
  width: 14px;
  height: 14px;
  background-size: 14px;
}
.subscription-box {
  border-radius: 6px;
  background: #FFFFFF;
  margin-top: 24px
}
  .border-bottom-dashed {
  border-bottom: 1px dashed #E5E7EB;
}
  

.compact-accordion .accordion-header button {
  padding: 1px 10px !important;
  min-height: 30px;
  display: flex;
  align-items: center;
}

.accordion-title-text {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #111827;
  line-height: 1;
}

.header-date-range {
  font-size: 12px !important;
  font-weight: 400;
  line-height: 1;
}

.accordion-edit-btn {
  color: #CBA370 !important;
  padding: 2px 6px !important;
  text-decoration: none !important;
  font-size: 12px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  line-height: 1 !important;
}

.accordion-edit-btn:hover {
  background-color: #FFF7ED !important;
  border-radius: 4px;
}

/* Compact status badge sizing */
.status-badge {
  font-size: 10.5px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 50px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  height: 20px;
}

.status-badge.active {
  background-color: #E6F4EA;
  color: #137333;
}

.status-badge.inactive {
  background-color: #FCE8E6;
  color: #C5221F;
}

.custom-arrow-parent {
  width: 18px;
  border-radius: 4px;
  background: #FFF7ED;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #D4A373;
  font-size: 16px;
  line-height: 1;
  padding-bottom: 2px;
  transition: transform 0.2s ease;
}
.custom-arrow {
  height: 100%;
  width:: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.question-row {
  border-top: 1px dashed #E5E7EB;
  padding: 12px 0px;
}
.accordion-button::after {
  display: none !important;
}
.accordion-button.collapsed .custom-arrow {
  transform: rotate(180deg);
}
.question-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}
.option-label {
  font-size: 12.5px;
  color: #6B7280;
}
.checked-option {
  color: #D4A373;
  font-weight: 500;
}
.custom-radio {
  appearance: none;
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  border: 1.5px solid #9CA3AF;
  border-radius: 50%;
  position: relative;
  cursor: default;
}
.custom-radio:checked {
  border-color: #D4A373;
}
.custom-radio:checked::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  background: #D4A373;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.user-avatar {
  width: 60px !important;
  height: 60px !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 20px;
  background-color: #CBA37033;
  color: #CBA370;                         
}
.edit-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #E5E7EB;
}
.edit-btn {
  background: none;
  border: none;
  color: #CBA370;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
  font-size: 12px;
}
.edit-btn:hover {
  background-color: #FFF7ED;
}
.edit-input {
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 14px;
  width: 100%;
  max-width: 250px;
  transition: border-color 0.2s;
}
.edit-input:focus {
  border-color: #CBA370;
  outline: none;
  box-shadow: 0 0 0 3px rgba(203, 163, 112, 0.1);
}
.edit-input:disabled {
  background-color: #F9FAFB;
  cursor: not-allowed;
}
.edit-input.error {
  border-color: #DC3545;
}
.edit-input.error:focus {
  border-color: #DC3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}
.password-toggle-btn {
  background: none;
  border: none;
  color: #6B7280;
  font-size: 12px;
  padding: 4px 8px;
  cursor: pointer;
}
.password-toggle-btn:hover {
  color: #CBA370;
}
.validation-error {
  color: #DC3545;
  font-size: 11px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
/* Subscription Edit Styles */
.subscription-edit-section {
  background-color: #FFFAF0;
  border: 1px solid #CBA370;
  border-radius: 8px;
  padding: 16px;
  margin-top: 12px;
}
.subscription-edit-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}
.subscription-edit-value {
  font-size: 14px;
  font-weight: 500;
  color: #CBA370;
}
.subscription-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  color: #374151;
  transition: all 0.2s;
}
.subscription-select:focus {
  border-color: #CBA370;
  outline: none;
  box-shadow: 0 0 0 3px rgba(203, 163, 112, 0.1);
}
.subscription-edit-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  justify-content: flex-end;
}

/* CRITICAL FIX: Drawer overlay styles - COMPLETELY PREVENTS INTERACTION WITH MAIN PAGE */
body.drawer-open {
  overflow: hidden !important;
  position: fixed !important;
  width: 100% !important;
  height: 100% !important;
  touch-action: none !important;
}

.drawer-backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background-color: rgba(0, 0, 0, 0.4) !important;
  z-index: 1049 !important;
  animation: fadeIn 0.3s ease;
  pointer-events: auto !important; /* This BLOCKS all clicks */
  cursor: default !important;
}

/* Prevent any click events from passing through */
.drawer-backdrop * {
  pointer-events: none !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.user-drawer {
  position: fixed !important;
  right: 0 !important;
  top: 0 !important;
  height: 100vh !important;
  width: 572px !important;
  background-color: white !important;
  box-shadow: -5px 0 15px rgba(0,0,0,0.1) !important;
  z-index: 1050 !important;
  overflow-y: hidden !important;
  pointer-events: auto !important;
  transform: translateX(0);
  animation: slideIn 0.3s ease;
}

/* Ensure drawer content is clickable */
.user-drawer * {
  pointer-events: auto !important;
}
`;

const DetailItem = ({ label, value, icon, isEditing, onEdit, field, fieldType, onFieldChange, showPassword = false, onTogglePassword, error, onBlur }) => {
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    if (onFieldChange) {
      onFieldChange(field, newValue);
    }
  };

  const getInputType = () => {
    if (field === 'password') {
      return showPassword ? 'text' : 'password';
    }
    if (field === 'dob') {
      return 'date';
    }
    if (field === 'contactNumber') {
      return 'tel';
    }
    if (field === 'email') {
      return 'email';
    }
    return 'text';
  };

  const displayValue = () => {
    if (field === 'password' && !isEditing) {
      return '••••••••';
    }
    return value || 'N/A';
  };

  return (
    <div className={`personal-fields ${isEditing ? 'editing' : ''} ${error ? 'error' : ''}`}>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <span className="me-2 d-flex px-4" style={{ color: '#CBA370' }}>{icon}</span>
          <span style={{ color: '#000000', fontSize: '14px' }}>{label}</span>
        </div>
        <div className="d-flex align-items-center gap-2">
          {isEditing ? (
            <div className="d-flex align-items-center gap-2">
              {field === 'password' ? (
                <div className="d-flex flex-column align-items-end">
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type={getInputType()}
                      value={localValue}
                      onChange={handleChange}
                      onBlur={onBlur}
                      placeholder="Enter new password"
                      className={`edit-input ${error ? 'error' : ''}`}
                      style={{ maxWidth: '200px' }}
                    />
                    <button
                      className="password-toggle-btn"
                      onClick={onTogglePassword}
                      type="button"
                    >
                      {showPassword ? 'Hide' : 'Show'}
                    </button>
                  </div>
                  {error && (
                    <div className="validation-error">
                      <AlertCircle size={12} />
                      {error}
                    </div>
                  )}
                </div>
              ) : (
                <div className="d-flex flex-column align-items-end">
                  <input
                    type={getInputType()}
                    value={localValue}
                    onChange={handleChange}
                    onBlur={onBlur}
                    className={`edit-input ${error ? 'error' : ''}`}
                    style={{ maxWidth: field === 'dob' ? '160px' : '220px' }}
                  />
                  {error && (
                    <div className="validation-error">
                      <AlertCircle size={12} />
                      {error}
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            <span style={{
              color: '#CBA370',
              fontWeight: '500',
              fontSize: '14px',
              textAlign: 'right',
              cursor: field === 'password' ? 'default' : 'pointer'
            }}>
              {displayValue()}
            </span>
          )}
          {field !== 'password' && (
            <button
              className="edit-btn"
              onClick={() => onEdit(field)}
              style={{ color: isEditing ? '#CBA370' : '#9CA3AF' }}
            >
              {isEditing ? <Check size={14} /> : <Edit2 size={14} />}
            </button>
          )}
          {field === 'password' && (
            <button
              className="edit-btn"
              onClick={() => onEdit(field)}
              style={{ color: isEditing ? '#CBA370' : '#9CA3AF' }}
            >
              {isEditing ? <Check size={14} /> : <Edit2 size={14} />}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const FormQuestion = ({ question, options, selectedValue, icon, isEditing, onOptionChange, field }) => (
  <div className="question-row">
    <div className="question-title d-flex align-items-center gap-2">
      {icon}
      <span>{question}</span>
    </div>
    <div>
      {options.map((option, index) => (
        <div key={index} className="option-item">
          {isEditing ? (
            <input
              type="radio"
              checked={option === selectedValue}
              onChange={() => onOptionChange(field, option)}
              className="custom-radio"
              style={{ cursor: 'pointer' }}
            />
          ) : (
            <input
              type="radio"
              checked={option === selectedValue}
              readOnly
              className="custom-radio"
            />
          )}
          <span className={`option-label ${option === selectedValue ? 'checked-option' : ''}`}>
            {option}
          </span>
        </div>
      ))}
    </div>
  </div>
);

const MultiSelectQuestion = ({ question, options, selectedValues, icon, isEditing, onOptionChange, field }) => (
  <div className="question-row">
    <div className="question-title d-flex align-items-center gap-2">
      {icon}
      <span>{question}</span>
    </div>
    <div>
      {options.map((option, index) => (
        <div key={index} className="option-item">
          {isEditing ? (
            <input
              type="checkbox"
              checked={selectedValues.includes(option)}
              onChange={(e) => {
                const newValues = e.target.checked
                  ? [...selectedValues, option]
                  : selectedValues.filter(v => v !== option);
                onOptionChange(field, newValues);
              }}
              className="custom-radio"
              style={{ cursor: 'pointer' }}
            />
          ) : (
            <input
              type="checkbox"
              checked={selectedValues.includes(option)}
              readOnly
              className="custom-radio"
            />
          )}
          <span className={`option-label ${selectedValues.includes(option) ? 'checked-option' : ''}`}>
            {option}
          </span>
        </div>
      ))}
    </div>
  </div>
);

const SingleValueQuestion = ({ question, value, icon }) => (
  <div className="question-row">
    <div className="question-title d-flex align-items-center gap-2">
      {icon}
      <span>{question}</span>
    </div>
    <div className="option-item">
      <input
        type="checkbox"
        checked={true}
        readOnly
        className="custom-radio"
      />
      <span className="option-label checked-option">
        {value || 'N/A'}
      </span>
    </div>
  </div>
);

const FilterUserDrawer = ({ selectedUser, onClose, onUpdateUser, onUpdateSuccess }) => {
  const [activeTab, setActiveTab] = useState('personal');
  const [editingFields, setEditingFields] = useState({});
  const [editedData, setEditedData] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [errors, setErrors] = useState({});
  const [professionalSituations, setProfessionalSituations] = useState([]);
  const [isEditingSubscription, setIsEditingSubscription] = useState(false);
  const [editedSubscription, setEditedSubscription] = useState(null);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [isLoadingSituations, setIsLoadingSituations] = useState(false);

  // CRITICAL FIX: Prevent body scroll and ALL interactions when drawer is open
  useEffect(() => {
    // Store original body styles
    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalWidth = document.body.style.width;
    const originalHeight = document.body.style.height;
    const originalTouchAction = document.body.style.touchAction;
    
    // Prevent body scroll and interactions
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    document.body.style.touchAction = 'none';
    document.body.classList.add('drawer-open');
    
    // CRITICAL: Add event listener to prevent all clicks on main content
    const preventClicks = (e) => {
      // Check if click target is inside the drawer
      const drawer = document.querySelector('.user-drawer');
      if (drawer && !drawer.contains(e.target)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      return true;
    };
    
    document.addEventListener('click', preventClicks, true);
    document.addEventListener('mousedown', preventClicks, true);
    document.addEventListener('mouseup', preventClicks, true);
    
    return () => {
      // Restore body styles
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.width = originalWidth;
      document.body.style.height = originalHeight;
      document.body.style.touchAction = originalTouchAction;
      document.body.classList.remove('drawer-open');
      
      // Remove event listeners
      document.removeEventListener('click', preventClicks, true);
      document.removeEventListener('mousedown', preventClicks, true);
      document.removeEventListener('mouseup', preventClicks, true);
    };
  }, []);

  // Validation functions
  const validateEmail = (email) => {
    if (!email) return 'Email is required';
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address (e.g., user@domain.com)';
    }
    return '';
  };

  const validatePassword = (password) => {
    if (!password) return ''; // Password is optional
    if (password.length < 8) {
      return 'Password must be at least 8 characters long';
    }
    if (!/[A-Z]/.test(password)) {
      return 'Password must contain at least one uppercase letter';
    }
    if (!/[a-z]/.test(password)) {
      return 'Password must contain at least one lowercase letter';
    }
    if (!/[0-9]/.test(password)) {
      return 'Password must contain at least one number';
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      return 'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)';
    }
    return '';
  };

  const validateField = (field, value) => {
    let error = '';
    if (field === 'email') {
      error = validateEmail(value);
    } else if (field === 'password' && value) {
      error = validatePassword(value);
    }
    return error;
  };

  const handleValidateField = (field, value) => {
    const error = validateField(field, value);
    setErrors(prev => ({ ...prev, [field]: error }));
    return error;
  };

  // Fetch professional situations
  useEffect(() => {
    const fetchProfessionalSituations = async () => {
      try {
        setIsLoadingSituations(true);
        const response = await getProfessionalSituation();
        if (response && response.Data) {
          // Filter only active situations
          const activeSituations = response.Data.filter(item => item.IsActive === '1');
          setProfessionalSituations(activeSituations);
        }
      } catch (error) {
        console.error('Error fetching professional situations:', error);
      } finally {
        setIsLoadingSituations(false);
      }
    };
    fetchProfessionalSituations();
  }, []);

  // Initialize edited data when user changes
  useEffect(() => {
    if (selectedUser) {
      const initialData = {
        contactNumber: selectedUser.contactNumber || '',
        email: selectedUser.email || '',
        dob: selectedUser.dob || '',
        emailAlert: selectedUser.emailAlert || false,
        pushAlert: selectedUser.pushAlert || false,
        password: '',
        firstName: selectedUser.firstName || '',
        lastName: selectedUser.lastName || '',
        userID: selectedUser.userID || selectedUser.id || ''
      };
      setEditedData(initialData);
      setErrors({});
    }
  }, [selectedUser]);

  if (!selectedUser) return null;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (e) {
      return dateString;
    }
  };

  const getYesNo = (value) => {
    if (value === 1 || value === true) return 'Yes';
    if (value === 0 || value === false) return 'No';
    return 'N/A';
  };

  const handleEditToggle = (field) => {
    if (editingFields[field]) {
      const value = editedData[field] || '';
      const error = handleValidateField(field, value);
      if (!error) {
        setEditingFields(prev => ({ ...prev, [field]: false }));
        setHasChanges(true);
      }
    } else {
      setEditingFields(prev => ({ ...prev, [field]: true }));
      if (field === 'password') {
        setEditedData(prev => ({ ...prev, password: '' }));
        setShowPassword(false);
        setErrors(prev => ({ ...prev, password: '' }));
      }
    }
  };

  const handleFieldChange = (field, value) => {
    setEditedData(prev => ({ ...prev, [field]: value }));
    setHasChanges(true);
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const handleFieldBlur = (field, value) => {
    if (field === 'email' || field === 'password') {
      handleValidateField(field, value);
    }
  };

  const handleTogglePassword = () => {
    setShowPassword(prev => !prev);
  };

  const handleUndoChanges = () => {
    const initialData = {
      contactNumber: selectedUser.contactNumber || '',
      email: selectedUser.email || '',
      dob: selectedUser.dob || '',
      emailAlert: selectedUser.emailAlert || false,
      pushAlert: selectedUser.pushAlert || false,
      password: '',
      firstName: selectedUser.firstName || '',
      lastName: selectedUser.lastName || '',
      userID: selectedUser.userID || selectedUser.id || ''
    };
    setEditedData(initialData);
    setEditingFields({});
    setHasChanges(false);
    setShowPassword(false);
    setErrors({});
  };

  const validateAllFields = () => {
    const newErrors = {};
    let hasError = false;

    if (editedData.email !== selectedUser.email) {
      const emailError = validateEmail(editedData.email);
      if (emailError) {
        newErrors.email = emailError;
        hasError = true;
      }
    }

    if (editedData.password && editedData.password.length > 0) {
      const passwordError = validatePassword(editedData.password);
      if (passwordError) {
        newErrors.password = passwordError;
        hasError = true;
      }
    }

    setErrors(newErrors);
    return !hasError;
  };

  const handleSaveChanges = async () => {
    try {
      if (!validateAllFields()) {
        const firstErrorField = Object.keys(errors)[0];
        if (firstErrorField) {
          const element = document.querySelector(`[data-field="${firstErrorField}"]`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
        return;
      }

      setIsSaving(true);

      const updateData = {
        UserID: editedData.userID || selectedUser.userID || selectedUser.id,
        EmailID: editedData.email || selectedUser.email,
        DOB: editedData.dob || selectedUser.dob,
        ContactNumber: editedData.contactNumber || selectedUser.contactNumber,
        FirstName: editedData.firstName || selectedUser.firstName || '',
        LastName: editedData.lastName || selectedUser.lastName || '',
        EmailAlert: editedData.emailAlert,
        PushAlert: editedData.pushAlert,
        Password: editedData.password || 'tempPassword123'
      };

      const result = await updateUserProfile(updateData);

      setEditingFields({});
      setHasChanges(false);
      setShowPassword(false);
      setErrors({});

      const updatedUserFromResponse = result.user || result;
      const mergedUpdatedUser = {
        ...selectedUser,
        email: updateData.EmailID,
        dob: updateData.DOB,
        contactNumber: updateData.ContactNumber,
        firstName: updateData.FirstName,
        lastName: updateData.LastName,
        emailAlert: updateData.EmailAlert,
        pushAlert: updateData.PushAlert,
        ...(updatedUserFromResponse && typeof updatedUserFromResponse === 'object' ? updatedUserFromResponse : {})
      };

      if (onUpdateUser) {
        onUpdateUser(mergedUpdatedUser);
      }
      if (onUpdateSuccess) {
        onUpdateSuccess();
      }

      setEditedData({
        contactNumber: mergedUpdatedUser.contactNumber || '',
        email: mergedUpdatedUser.email || '',
        dob: mergedUpdatedUser.dob || '',
        emailAlert: mergedUpdatedUser.emailAlert || false,
        pushAlert: mergedUpdatedUser.pushAlert || false,
        password: '',
        firstName: mergedUpdatedUser.firstName || '',
        lastName: mergedUpdatedUser.lastName || '',
        userID: mergedUpdatedUser.userID || mergedUpdatedUser.id || ''
      });

      console.log('Profile updated successfully:', result);

    } catch (error) {
      console.error('Error updating profile:', error);
    } finally {
      setIsSaving(false);
    }
  };

  // Subscription edit handlers
  const handleEditSubscription = (invoice) => {
    // Get the UsersSubscriptionID from the invoice
    const usersSubscriptionID = invoice.UsersSubscriptionID || invoice.ID;
    
    setSelectedInvoiceId(invoice.ID);
    setEditedSubscription({
      UsersSubscriptionID: usersSubscriptionID, // Store the UsersSubscriptionID separately
      InvoiceID: invoice.ID, // Store the Invoice ID for reference
      SubscriptionDetail: {
        SituationProfessionnelle: invoice.SubscriptionDetail?.SituationProfessionnelle || '',
        HorizonDePlacement: invoice.SubscriptionDetail?.HorizonDePlacement || '',
        ObjectifDePlacement: invoice.SubscriptionDetail?.ObjectifDePlacement || [],
        AversionAuRisque: invoice.SubscriptionDetail?.AversionAuRisque || ''
      }
    });
    setIsEditingSubscription(true);
  };

  const handleCancelSubscriptionEdit = () => {
    setIsEditingSubscription(false);
    setEditedSubscription(null);
    setSelectedInvoiceId(null);
  };

  const handleSubscriptionFieldChange = (field, value) => {
    setEditedSubscription(prev => ({
      ...prev,
      SubscriptionDetail: {
        ...prev.SubscriptionDetail,
        [field]: value
      }
    }));
  };

  const handleSaveSubscriptionChanges = async () => {
    // Check if we have the UsersSubscriptionID
    if (!editedSubscription?.UsersSubscriptionID) {
      console.warn('No UsersSubscriptionID found for save.');
      toast.error('Subscription ID not found. Please try again.');
      return;
    }

    try {
      setIsSaving(true);

      // Send the UsersSubscriptionID as ID in the payload
      const updateData = {
        ID: editedSubscription.UsersSubscriptionID, // This is the UsersSubscriptionID
        SubscriptionDetail: editedSubscription.SubscriptionDetail
      };

      const result = await updateInvestmentCriteria(updateData);

      const updatedSubscriptionDetail = result?.SubscriptionDetail || editedSubscription.SubscriptionDetail;

      // Update the selectedUser with new subscription data
      if (onUpdateUser) {
        const updatedUser = { ...selectedUser };
        if (updatedUser.InvoiceHistory) {
          const invoiceIndex = updatedUser.InvoiceHistory.findIndex(
            inv => inv.ID === editedSubscription.InvoiceID
          );
          if (invoiceIndex !== -1) {
            updatedUser.InvoiceHistory[invoiceIndex] = {
              ...updatedUser.InvoiceHistory[invoiceIndex],
              SubscriptionDetail: updatedSubscriptionDetail
            };
          }
        }
        onUpdateUser(updatedUser);
      }
      if (onUpdateSuccess) {
        onUpdateSuccess();
      }

      setIsEditingSubscription(false);
      setEditedSubscription(null);
      setSelectedInvoiceId(null);

    } catch (error) {
      console.error('Error updating subscription:', error);
      toast.error(error.response?.data?.message || 'Failed to update subscription');
    } finally {
      setIsSaving(false);
    }
  };

  const formQuestions = {
    situationProfessionnelle: {
      question: "Situation Professionnelle",
      icon: <Briefcase size={16} />,
    },
    horizon: {
      question: "Quel est votre horizon de placement ?",
      icon: <Clock size={16} />,
      options: [
        "Inférieur à 1 an",
        "Entre 1 an et 5 ans",
        "Supérieur à 5 ans"
      ]
    },
    objectif: {
      question: "Quel est votre objectif de placement ?",
      icon: <Target size={16} />,
      options: [
        "Construire un capital",
        "Générer un revenu complémentaire",
        "Préparer ma retraite",
        "Spéculer à court terme"
      ]
    },
    aversion: {
      question: "Quel est votre aversion au risque ?",
      icon: <Shield size={16} />,
      options: [
        "Conservateur",
        "Modéré",
        "Entrepreneur"
      ]
    }
  };

  const isSaveDisabled = isSaving || Object.values(errors).some(error => error !== '');

  return (
    <>
      <style>{customStyles}</style>
      
      {/* Backdrop overlay - COMPLETELY BLOCKS all clicks on main content */}
      <div 
        className="drawer-backdrop"
        onClick={(e) => {
          // This prevents any click events on the backdrop from doing anything
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
        onMouseUp={(e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
      />
      
      <div className="user-drawer">
        <div style={{
          padding: '10px 24px',
          backgroundColor: '#F8FDF8'
        }}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <div className="avatar-circle bg-primary-50 text-primary-600 me-3 user-avatar">
                {selectedUser.fullName ? selectedUser.fullName.charAt(0).toUpperCase() : 'U'}
              </div>
              <div>
                <div style={{ color: '#000000ff', fontWeight: '600', margin: 0, fontSize: '20px' }}>
                  {selectedUser.fullName || 'N/A'}
                </div>
              </div>
            </div>
            <Button
              variant="outline"
              onClick={onClose}
              style={{ border: 'none', color: '#000', padding: 0 }}
            >
              <X size={24} />
            </Button>
          </div>
        </div>

        <div style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 90px)' }}>
          <div>
            <div>
              <div className="d-flex" style={{ borderBottom: '4px solid #F0F0F0' }}>
                <Button
                  variant="link"
                  className="text-decoration-none px-80"
                  onClick={() => setActiveTab('personal')}
                  style={{
                    fontSize: '14px',
                    color: activeTab === 'personal' ? '#CBA370' : '#666',
                    fontWeight: activeTab === 'personal' ? '600' : 'normal',
                    backgroundColor: activeTab === 'personal' ? '#CBA37024' : 'transparent',
                    borderRadius: '4px 4px 0 0',
                    border: 'none',
                    borderBottom: activeTab === 'personal' ? '4px solid #CBA370' : '4px solid transparent',
                    marginRight: '10px',
                    transition: 'all 0.1s ease-in-out',
                    lineHeight: '1.2'
                  }}
                >
                  Personal Detail
                </Button>
                <Button
                  variant="link"
                  className="text-decoration-none px-80 text-capitalize"
                  onClick={() => setActiveTab('subscription')}
                  style={{
                    fontSize: '14px',
                    color: activeTab === 'subscription' ? '#CBA370' : '#666',
                    fontWeight: activeTab === 'subscription' ? '600' : 'normal',
                    backgroundColor: activeTab === 'subscription' ? '#CBA37024' : 'transparent',
                    borderRadius: '4px 4px 0 0',
                    border: 'none',
                    borderBottom: activeTab === 'subscription' ? '4px solid #CBA370' : '4px solid transparent',
                    transition: 'all 0.1s ease-in-out',
                    lineHeight: '1.2'
                  }}
                >
                  Subscription History
                </Button>
              </div>
            </div>

            <div className='p-10 mt-2'>
              {activeTab === 'personal' && (
                <div className='p-10 rounded' style={{ border: '1px solid #E5E7EB' }}>
                  <div className="mb-4">
                    <Col>
                      <DetailItem
                        label="First Name"
                        value={editedData.firstName}
                        icon={<Phone size={16} />}
                        isEditing={editingFields.firstName}
                        onEdit={handleEditToggle}
                        field="firstName"
                        onFieldChange={handleFieldChange}
                      />
                      <DetailItem
                        label="Last Name"
                        value={editedData.lastName}
                        icon={<Phone size={16} />}
                        isEditing={editingFields.lastName}
                        onEdit={handleEditToggle}
                        field="lastName"
                        onFieldChange={handleFieldChange}
                      />
                      <DetailItem
                        label="Phone Number"
                        value={editedData.contactNumber}
                        icon={<Phone size={16} />}
                        isEditing={editingFields.contactNumber}
                        onEdit={handleEditToggle}
                        field="contactNumber"
                        onFieldChange={handleFieldChange}
                      />
                      <DetailItem
                        label="Email"
                        value={editedData.email}
                        icon={<FileText size={16} />}
                        isEditing={editingFields.email}
                        onEdit={handleEditToggle}
                        field="email"
                        onFieldChange={handleFieldChange}
                        onBlur={() => handleFieldBlur('email', editedData.email)}
                        error={errors.email}
                      />
                      <DetailItem
                        label="Date Of Birth"
                        value={editedData.dob}
                        icon={<Calendar size={16} />}
                        isEditing={editingFields.dob}
                        onEdit={handleEditToggle}
                        field="dob"
                        onFieldChange={handleFieldChange}
                      />
                      <div className="personal-fields">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <span className="me-2 d-flex px-4" style={{ color: '#CBA370' }}>
                              <Mail size={16} />
                            </span>
                            <span style={{ color: '#000000', fontSize: '14px' }}>Subscription for email alert</span>
                          </div>
                          <div className="d-flex align-items-center justify-content-end gap-2" style={{ width: '50%' }}>
                            <Form.Check
                              type="switch"
                              id="email-alert-switch"
                              checked={editedData.emailAlert}
                              onChange={(e) => {
                                setEditedData(prev => ({ ...prev, emailAlert: e.target.checked }));
                                setHasChanges(true);
                              }}
                              className="mb-0 d-inline-flex align-items-center"
                              style={{
                                '--bs-form-switch-bg': 'url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e")',
                                margin: 0,
                                padding: 0
                              }}
                            />
                            <span style={{ color: '#CBA370', fontWeight: '500', fontSize: '14px', lineHeight: '1' }}>
                              {getYesNo(editedData.emailAlert)}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="personal-fields">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <span className="me-2 d-flex px-4" style={{ color: '#CBA370' }}>
                              <Bell size={16} />
                            </span>
                            <span style={{ color: '#000000', fontSize: '14px' }}>Subscription for Push Notification alert</span>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <Form.Check
                              type="switch"
                              id="push-alert-switch"
                              checked={editedData.pushAlert}
                              onChange={(e) => {
                                setEditedData(prev => ({ ...prev, pushAlert: e.target.checked }));
                                setHasChanges(true);
                              }}
                            />
                            <span style={{ color: '#CBA370', fontWeight: '500', fontSize: '14px' }}>
                              {getYesNo(editedData.pushAlert)}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="personal-fields">
                        <div className="mb-3 d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <span className="me-2 d-flex px-4" style={{ color: '#CBA370' }}>
                              <Calendar size={16} />
                            </span>
                            <span style={{ color: '#000000', fontSize: '14px' }}>Subscription Due Date</span>
                          </div>
                          <span style={{ color: '#CBA370', fontWeight: '500', fontSize: '14px', textAlign: 'right' }}>
                            {formatDate(selectedUser.subscriptionEndingDate) || 'N/A'}
                          </span>
                        </div>
                      </div>
                      <DetailItem
                        label="Password"
                        value={editedData.password || ''}
                        icon={<Shield size={16} />}
                        isEditing={editingFields.password}
                        onEdit={handleEditToggle}
                        field="password"
                        onFieldChange={handleFieldChange}
                        onBlur={() => handleFieldBlur('password', editedData.password)}
                        showPassword={showPassword}
                        onTogglePassword={handleTogglePassword}
                        error={errors.password}
                      />

                      {hasChanges && (
                        <div className="edit-actions d-flex justify-content-end gap-2">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={handleUndoChanges}
                            disabled={isSaving}
                            className="d-flex align-items-center gap-1"
                            style={{ borderColor: '#D1D5DB', color: '#6B7280' }}
                          >
                            <RefreshCw size={14} />
                            Undo Changes
                          </Button>
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={handleSaveChanges}
                            disabled={isSaveDisabled}
                            className="d-flex align-items-center gap-1"
                            style={{
                              backgroundColor: isSaveDisabled ? '#D1D5DB' : '#CBA370',
                              borderColor: isSaveDisabled ? '#D1D5DB' : '#CBA370',
                              color: 'white'
                            }}
                          >
                            {isSaving ? (
                              <>
                                <Spinner animation="border" size="sm" />
                                Saving...
                              </>
                            ) : (
                              <>
                                <Save size={14} />
                                Save Changes
                              </>
                            )}
                          </Button>
                        </div>
                      )}
                    </Col>
                  </div>
                </div>
              )}

              {activeTab === 'subscription' && (
                <div>
                  <div className="mb-4">
                    {selectedUser.InvoiceHistory && selectedUser.InvoiceHistory.length > 0 ? (
                      selectedUser.InvoiceHistory.map((invoice, index) => {
                        // Dynamic status check based on current date (2026)
                        const isSubscriptionActive = invoice.EndDate ? new Date(invoice.EndDate) > new Date() : false;

                        return (
                          <div key={invoice.ID || index} className="mb-3">
                            {invoice.StartDate && invoice.EndDate && (
                              <Accordion className="compact-accordion">
                                <Accordion.Item eventKey="0">
                                  <Accordion.Header>
                                    <div className="d-flex justify-content-between align-items-center w-100 pe-2">
                                      {/* Left Side: Icon & Title */}
                                      <div className="d-flex align-items-center gap-2 h-100">
                                        <Calendar size={14} className="text-muted" style={{ transform: 'translateY(-1px)' }} />
                                        <span className="accordion-title-text">
                                          {invoice.SubscriptionTitle || 'Subscription Plan'}
                                        </span>
                                      </div>

                                      {/* Right Side: Timeline Dates, Status, Actions */}
                                      <div className="d-flex align-items-center gap-3 h-100">
                                        {/* Compact Date Range */}
                                        <div className="d-none d-sm-block text-muted header-date-range">
                                          {formatDate(invoice.StartDate)} - {formatDate(invoice.EndDate)}
                                        </div>

                                        {/* Dynamic Status Badge */}
                                        <span className={`status-badge ${isSubscriptionActive ? 'active' : 'inactive'}`}>
                                          {isSubscriptionActive ? 'Active' : 'Inactive'}
                                        </span>

                                        {/* Actions Container with layout spacing matching image_73bfa0.png */}
                                        <div className="d-flex align-items-center gap-3 visual-actions-group">
                                          {!isEditingSubscription && (
                                            <Button
                                              variant="link"
                                              size="sm"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleEditSubscription(invoice);
                                              }}
                                              className="accordion-edit-btn"
                                            >
                                              <Edit2 size={13} />
                                              <span>Edit</span>
                                            </Button>
                                          )}
                                          <div className="custom-arrow-parent">
                                            <div className='custom-arrow'>
                                            ^
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    {/* Detailed View inside Body */}
                                    <div className="d-flex justify-content-between mb-3 pb-3 border-bottom-dashed">
                                      <div>
                                        <div style={{ fontSize: '12px', color: '#6B7280' }}>Start Date</div>
                                        <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                                          {formatDate(invoice.StartDate)}
                                        </div>
                                      </div>
                                      <div>
                                        <div style={{ fontSize: '12px', color: '#6B7280' }}>End Date</div>
                                        <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                                          {formatDate(invoice.EndDate)}
                                        </div>
                                      </div>
                                    </div>

                                    {invoice.SubscriptionDetail && (
                                      <div className="subscription-box" style={{ padding: '0px', marginTop: '12px' }}>
                                        {isEditingSubscription && selectedInvoiceId === invoice.ID ? (
                                          <div className="subscription-edit-section">
                                            <div style={{ marginBottom: '12px' }}>
                                              <div className="subscription-edit-label">
                                                {formQuestions.situationProfessionnelle.question}
                                              </div>
                                              <select
                                                className="subscription-select"
                                                value={editedSubscription?.SubscriptionDetail?.SituationProfessionnelle || ''}
                                                onChange={(e) => handleSubscriptionFieldChange('SituationProfessionnelle', e.target.value)}
                                                disabled={isLoadingSituations}
                                              >
                                                <option value="">Select Situation</option>
                                                {professionalSituations.map((situation) => (
                                                  <option key={situation.ID} value={situation.Value}>
                                                    {situation.Value}
                                                  </option>
                                                ))}
                                              </select>
                                            </div>

                                            <FormQuestion
                                              question={formQuestions.horizon.question}
                                              options={formQuestions.horizon.options}
                                              selectedValue={editedSubscription?.SubscriptionDetail?.HorizonDePlacement || ''}
                                              icon={formQuestions.horizon.icon}
                                              isEditing={true}
                                              onOptionChange={handleSubscriptionFieldChange}
                                              field="HorizonDePlacement"
                                            />

                                            <MultiSelectQuestion
                                              question={formQuestions.objectif.question}
                                              options={formQuestions.objectif.options}
                                              selectedValues={editedSubscription?.SubscriptionDetail?.ObjectifDePlacement || []}
                                              icon={formQuestions.objectif.icon}
                                              isEditing={true}
                                              onOptionChange={handleSubscriptionFieldChange}
                                              field="ObjectifDePlacement"
                                            />

                                            <FormQuestion
                                              question={formQuestions.aversion.question}
                                              options={formQuestions.aversion.options}
                                              selectedValue={editedSubscription?.SubscriptionDetail?.AversionAuRisque || ''}
                                              icon={formQuestions.aversion.icon}
                                              isEditing={true}
                                              onOptionChange={handleSubscriptionFieldChange}
                                              field="AversionAuRisque"
                                            />

                                            <div className="subscription-edit-actions">
                                              <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                className='d-flex justify-content-center align-items-center'
                                                onClick={handleCancelSubscriptionEdit}
                                                disabled={isSaving}
                                                style={{ borderColor: '#D1D5DB' }}
                                              >
                                                <X size={14} className="me-1" />
                                                Cancel
                                              </Button>
                                              <Button
                                                type="button"
                                                variant="primary"
                                                size="sm"
                                                className='d-flex justify-content-center align-items-center'
                                                onClick={handleSaveSubscriptionChanges}
                                                disabled={isSaving}
                                                style={{
                                                  backgroundColor: '#CBA370',
                                                  borderColor: '#CBA370',
                                                  color: 'white'
                                                }}
                                              >
                                                {isSaving ? (
                                                  <>
                                                    <Spinner animation="border" size="sm" />
                                                    Saving...
                                                  </>
                                                ) : (
                                                  <>
                                                    <Save size={14} className="me-1" />
                                                    Save Changes
                                                  </>
                                                )}
                                              </Button>
                                            </div>
                                          </div>
                                        ) : (
                                          <>
                                            <SingleValueQuestion
                                              question={formQuestions.situationProfessionnelle.question}
                                              value={invoice.SubscriptionDetail.SituationProfessionnelle}
                                              icon={formQuestions.situationProfessionnelle.icon}
                                            />
                                            <FormQuestion
                                              question={formQuestions.horizon.question}
                                              options={formQuestions.horizon.options}
                                              selectedValue={invoice.SubscriptionDetail.HorizonDePlacement}
                                              icon={formQuestions.horizon.icon}
                                            />
                                            <MultiSelectQuestion
                                              question={formQuestions.objectif.question}
                                              options={formQuestions.objectif.options}
                                              selectedValues={invoice.SubscriptionDetail.ObjectifDePlacement || []}
                                              icon={formQuestions.objectif.icon}
                                            />
                                            <FormQuestion
                                              question={formQuestions.aversion.question}
                                              options={formQuestions.aversion.options}
                                              selectedValue={invoice.SubscriptionDetail.AversionAuRisque}
                                              icon={formQuestions.aversion.icon}
                                            />
                                          </>
                                        )}
                                      </div>
                                    )}
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <div className="empty-state">
                        <Icon icon="mdi:file-document-outline" width={48} height={48} style={{ color: '#CBD5E1', marginBottom: '16px' }} />
                        <div style={{ color: '#6B7280', fontSize: '14px' }}>
                          No subscription history found
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterUserDrawer;